/**
 * Store del saldo del socio · Sprint 40 · CT Connect V1.
 *
 * Único punto de acceso al saldo desde el frontend. NUNCA se cachea
 * en localStorage: los datos financieros los expone sólo la API con
 * la cookie HttpOnly de sesión.
 *
 * Contrato del backend (GET /api/socios/me/saldo):
 *   { numeroSocio, disponible, saldoActualizacion, saldoTotal,
 *     saldoCuotas, saldoConsumos, inconsistente, mensaje }
 *
 *   - `disponible=false` → Casino Tampiqueño aún no ha entregado el saldo del
 *     socio; la UI muestra "Pendiente / no disponible" en vez de 0.
 *   - `inconsistente=true` → saldoTotal ≠ cuotas + consumos (fuera de
 *     tolerancia 0.01); la UI lo señala para revisión.
 */

import { api } from "@/services/api";

export async function obtenerSaldoSocio() {
  const { data } = await api.get("/socios/me/saldo");
  return data;
}

/**
 * Formatea una fecha ISO como "hace X minutos/horas/días" en es-MX.
 * Devuelve texto amigable, o "—" si la fecha es null.
 */
export function tiempoRelativo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const seg = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));

  if (seg < 60) return "hace unos segundos";
  const min = Math.floor(seg / 60);
  if (min < 60)
    return `hace ${min} ${min === 1 ? "minuto" : "minutos"}`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `hace ${hr} ${hr === 1 ? "hora" : "horas"}`;
  const dias = Math.floor(hr / 24);
  if (dias < 30) return `hace ${dias} ${dias === 1 ? "día" : "días"}`;
  const meses = Math.floor(dias / 30);
  if (meses < 12)
    return `hace ${meses} ${meses === 1 ? "mes" : "meses"}`;
  const years = Math.floor(meses / 12);
  return `hace ${years} ${years === 1 ? "año" : "años"}`;
}

/** Formatea número a MXN sin fracciones de centavo perdidas. */
export function fmtMxn(n) {
  if (n === null || n === undefined) return "—";
  try {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `$${Number(n).toFixed(2)}`;
  }
}
